import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 12H4v6.586l3.115-3.115A5.961 5.961 0 016 12zm4.586 0H8c0 .739.216 1.425.566 2.02l2.02-2.02zM16 12h-2.586l2.02 2.02c.35-.595.566-1.281.566-2.02zm4 0h-2c0 1.294-.416 2.49-1.115 3.471L20 18.586V12zM9.98 15.434c.595.35 1.281.566 2.02.566.739 0 1.425-.216 2.02-.566L12 13.414l-2.02 2.02zM5.414 20h13.172l-3.115-3.115a5.961 5.961 0 01-6.942 0L5.414 20zM2 12v-2h20v10c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-8zm0-4V6h20v2H2zm18-6a2 2 0 012 2H2a2 2 0 012-2h16z"
    />
  </svg>
);
